import { Col, Row } from "antd";
import { ProfileDropdown } from "../ProfileDropdown";
import * as S from "../styles";

interface MobileHeaderProps {
  toggleSider: () => void;
  isSiderOpened: boolean;
}

export const MobileHeader = ({
  toggleSider,
  isSiderOpened,
}: MobileHeaderProps) => {
  return (
    <Row
      justify="space-between"
      align="middle"
      style={{ paddingTop: "1rem", paddingBottom: ".8rem" }}
    >
      <S.BurgerCol span={16}>
        <S.MobileBurger onClick={toggleSider} isCross={isSiderOpened} />
      </S.BurgerCol>
      <Col
        span={8}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <ProfileDropdown />
      </Col>
    </Row>
  );
};
